import { Accordion, Center, Flex, Loader, Stack } from "@mantine/core";
import type { ChangeEventHandler, ReactNode, RefObject } from "react";
import { IsDoneBadge } from "../../../components/IsDoneBadge";
import { MissingDataActionButton } from "../../../components/MissingDataActionButton";

function clearFileInput(fileInputRef: RefObject<HTMLInputElement | null>) {
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
}

type VollmachtSectionProps = {
  actions: ReactNode;
  done: boolean;
  hasMissingData: boolean;
  isDisabled?: boolean;
  isLoading: boolean;
  missingDataRoute: string;
  objectName: string;
  fileInputAccept?: string;
  fileInputRef?: RefObject<HTMLInputElement | null>;
  onFileChange?: ChangeEventHandler<HTMLInputElement>;
  trailingContent?: ReactNode;
};

function VollmachtSection({
  actions,
  done,
  hasMissingData,
  isDisabled,
  isLoading,
  missingDataRoute,
  objectName,
  fileInputAccept,
  fileInputRef,
  onFileChange,
  trailingContent
}: VollmachtSectionProps) {
  if (isLoading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  const missingDataAction = (
    <MissingDataActionButton disabled={isDisabled} route={missingDataRoute}>
      Fehlende Daten ergänzen
      <br />
      (für {objectName})
    </MissingDataActionButton>
  );

  return (
    <>
      <Accordion.Item
        style={{
          boxShadow: "none"
        }}
        value={done ? `${missingDataRoute}-done` : missingDataRoute}
      >
        <Flex align="center">
          <Accordion.Control
            disabled={isDisabled || done}
            fz="sm"
            h="auto"
            styles={{
              label: {
                fontWeight: 600
              },
              control: {
                cursor: isDisabled || done ? "text" : "pointer",
                userSelect: "text",
                WebkitUserSelect: "text",
                MozUserSelect: "text",
                msUserSelect: "text"
              }
            }}
          >
            {`Vollmacht(en) für ${objectName}`}
          </Accordion.Control>
          <IsDoneBadge isDone={done} />
        </Flex>

        <Accordion.Panel
          styles={{
            content: {
              padding:
                "0px var(--mantine-spacing-md) 0px var(--mantine-spacing-xxl, 40px)"
            }
          }}
        >
          <Stack gap="xs">{hasMissingData ? missingDataAction : actions}</Stack>
        </Accordion.Panel>
      </Accordion.Item>

      {fileInputRef && onFileChange && (
        <input
          accept={fileInputAccept}
          hidden
          ref={fileInputRef}
          type="file"
          onChange={onFileChange}
        />
      )}

      {trailingContent}
    </>
  );
}

export { clearFileInput, VollmachtSection };
